<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addPrizes">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('prizes')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    
    <!-- Modal de confirmação de exclusão -->
    <CModal
      :show.sync="showDeleteModal"
      :title="$t('confirmDelete')"
      color="primary"
    >
      <p>{{ $t('confirmRemove', { name: prizeToDelete && prizeToDelete.title ? prizeToDelete.title : '' }) }}</p>
      <template #footer>
        <CButton @click="showDeleteModal = false" color="secondary">{{ $t('cancel') }}</CButton>
        <CButton @click="confirmDelete" color="primary" :disabled="deleting">
          <CSpinner v-if="deleting" size="sm" class="mr-1"></CSpinner>
          {{ $t('delete') }}
        </CButton>
      </template>
    </CModal>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
        { key: 'year', label: i18n.t('year'), sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      showDeleteModal: false,
      prizeToDelete: null,
      deleting: false
    }
  },
  computed: {
    ...mapState('prizes', ['getPrizesOutput']),
    ...mapState('prizes', ['deletePrizeByIdOutput']),
    prizesInfo: function() {
      return this.getPrizesOutput ? this.getPrizesOutput : null;
    },
    items: function()
    {
      return this.prizesInfo && this.prizesInfo.data ? this.prizesInfo.data : [];
    },
    pages: function()
    {
      return this.prizesInfo ? this.prizesInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('prizes', ['getPrizes']),
    ...mapActions('prizes', ['deletePrizeById']),
    rowClicked (item, index) {
      this.$router.push({name: "PrizesEdit", query: { id: item.id }, params: { title: item.title } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "PrizesEdit", query: { id: item.id }, params: { title: item.title } });
          break;
        }
        case 'remove':
        {
          this.openDeleteModal(item);
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      
      this.getPrizes(input); 
    },
    addPrizes () 
    {
      router.push({ name: 'PrizesAdd' });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },
    openDeleteModal(item) {
      this.prizeToDelete = item;
      this.showDeleteModal = true;
    },
    confirmDelete() {
      if (!this.prizeToDelete) return;
      
      this.deleting = true;
      this.deletePrizeById(this.prizeToDelete.id);
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deletePrizeByIdOutput: function(val)
    {
      this.loading = true;
      this.deleting = false;
      this.showDeleteModal = false;
      this.prizeToDelete = null;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getPrizesOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 